import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content', 'button'];

  connect() {
    const controller = this
    if (controller.hasContentTarget && controller.hasButtonTarget) {
      if (controller.contentTarget.classList.contains('hidden')) {
        this.setCollapsed(controller.buttonTarget)
      } else {
        this.setExpanded(controller.buttonTarget)
      }
    }
  }

  toggleContent(event) {
    const controller = this
    let button = event.currentTarget
    if (controller.hasContentTarget) {
      controller.contentTarget.classList.toggle('hidden')
      if (controller.contentTarget.classList.contains('hidden')) {
        this.setCollapsed(button)
      } else {
        this.setExpanded(button)
      }
    }
  }

  setExpanded(button) {
    let icon = button.querySelector('i.indicator.icon');
    if (button._tippy) {
      button._tippy.setContent('Collapse')
    } else {
      button.dataset.tippyContent = 'Collapse'
    }
    icon.classList.remove('collapsed')
    icon.classList.add('expanded')
  }

  setCollapsed(button) {
    let icon = button.querySelector('i.indicator.icon');
    if (button._tippy) {
      button._tippy.setContent('Expand')
    } else {
      button.dataset.tippyContent = 'Expand'
    }
    icon.classList.remove('expanded')
    icon.classList.add('collapsed')
  }
}

